import { getStatsSchema } from "../components/seo/getStatsSchema";
import SEO from "../components/seo/SEO";
import BrowseCategories from "./BrowseCategories";
import FinalCTA from "./FinalCTA";
import HomeHero from "./HomeHero";
import HowItWorks from "./HowItWorks";
import PopularCities from "./PopularCities";
import StatsSection from "./StatsSection";
import WhyNearbyGuide from "./WhyNearbyGuide";

const Home = () => {
  return (
    <>
      <SEO>
        <script type="application/ld+json">
          {JSON.stringify(getStatsSchema)}
        </script>
      </SEO>
      <HomeHero />
      <BrowseCategories />
      <PopularCities />
      {/* <FeaturedPlaces /> */}
      <StatsSection />
      <HowItWorks />
      <WhyNearbyGuide />
      <FinalCTA />
    </>
  );
};

export default Home;
